import ConfigStore, { IReportModel } from '../Stores/ConfigStore'
import LocalizationStore from '../Stores/LocalizationStore'

export default class ReportsService {

    public static getIframeLocalizationKey(report: string): string {
        const cs = ConfigStore.getInstance()
        let localizationKey: string = ''
        try {
            localizationKey = cs.getReportsIframes.filter(x => x.Key === report)[0].Key
            // console.info(report, 'report')
            // console.info(ls.lang, 'lang')
            // console.info(iframe, 'iframe111')
        } finally {
            localizationKey = localizationKey ? localizationKey : ''
        }
        // console.info(iframe, 'iframe')
        return localizationKey
    }

    public static getIframe(report: string): string {
        const ls = LocalizationStore.getInstance()
        const cs = ConfigStore.getInstance()
        let iframe: string = ''
        try {
            iframe = cs.getReportsIframes.filter(x => x.Key === report)[0][ls.lang]
            // console.info(report, 'report')
            // console.info(ls.lang, 'lang')
            // console.info(iframe, 'iframe111')
        } finally {
            iframe = iframe ? iframe : ''
        }
        // console.info(iframe, 'iframe')
        return iframe
    }

    public static getIframes(): Array<IReportModel> {
        const cs = ConfigStore.getInstance()
        return cs.getReportsIframes
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Services/ReportsService.tsx